/**
 *
 * This is a JavaScript BlackMostros Template.
 *
 * @source: http://www.pronia.es/templates/black-mostros
 *
 * @licstart  The following is the entire license notice for the
 *  JavaScript code in this page.
 *
 * Copyright (C) 2014  David Lemos González
 *
 *
 * The JavaScript code in this page is free software: you can
 * redistribute it and/or modify it under the terms of the GNU
 * General Public License (GNU GPL) as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option)
 * any later version.  The code is distributed WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE.  See the GNU GPL for more details.
 *
 * As additional permission under GNU GPL version 3 section 7, you
 * may distribute non-source (e.g., minimized or compacted) forms of
 * that code without the copy of the GNU GPL normally required by
 * section 4, provided you include this license notice and a URL
 * through which recipients can access the Corresponding Source.
 *
 * @licend  The above is the entire license notice
 * for the JavaScript code in this page.
 *
 */

import {
  ajax,

  // when_available,
  // when_document_ready,
  // _run_site_ads,
  // fetch_style,
  // console_if_debug,
  // call_each_n_miliseconds,
  } from './blackmostros.method.js';


var Pronia = (function() {

  //"./index.php?option=com_ajax&module=pronia&method=getMiner&format=json"
  var _path = './',
    _index = 'index',
    _tech = 'php',
    _dotsep = '.',
    _url = {
      option: {
        prefix: 'com',
        name: 'ajax'
        },
      module : {
        name: 'pronia',
      },
      method : {
        get_miner: 'Miner',
        get_currency_exchange: 'CurrencyExchange',
        get_new_subscription: 'NewSubscription',
        activate_subscription: 'ActivateSubscription',
        get_payment_data: 'PaymentData',
        get_subscription_deals_data: 'SubscriptionDealsData',
        get_subscription_messages_data: 'SubscriptionMessagesData',
        },
      format: 'json',
      sep: '_',
    },
    _method = {
      _get: 'get',
    },
    _ajax = new ajax(),
    _stripe = {},
    mpublic = {
      stripe: _stripe
      };

  function _get_format_string(){
    return `${Object.keys(_url)[3]}=${_url.format}`;
  }

  function _get_string(name, prefix, value) {
    return `${name}=${prefix}${_url.sep}${value}`;
  }

  function _get_url_option(index){
    let name = Object.keys(_url)[index];
    return _get_string(
      name,
      _url[name].prefix,
      _url[name].name
      );
  }

  function _get_option(){
    return _get_url_option(0);
    // return _get_string(
    //   Object.keys(_url)[0],
    //   _url.option.prefix,
    //   _url.option.name
    //   );
  }

  function _get_module(){
    return `${Object.keys(_url)[1]}=${_url.module.name}`;
  }

  function _get_method(name){
    return `${Object.keys(_url)[2]}=${_method._get}${name}`;
  }

  function _get_url(name){
    let method = _get_method(_url.method[name]);
    return `${_path}${_index}${_dotsep}${_tech}?${_get_option()}&${_get_module()}&${method}&${_get_format_string()}`;
  }

  function _get_miner_data(){
    let _curl = _get_url('get_miner');
    // ~ console.log(_curl);
    return _ajax.get(_curl);
  }
  mpublic.get_miner_data = _get_miner_data;

  function _get_currency_exchange_data(){
    let _curl = _get_url('get_currency_exchange');
    return fetch(_curl);
    /*
    return {"success":true,"message":null,"messages":null,"data":{"coin":[{"disclaimer":"Usage subject to terms: https:\/\/openexchangerates.org\/terms","license":"https:\/\/openexchangerates.org\/license","timestamp":1567508400,"base":"USD","rates":{"AED":3.673158,"AFN":77.968,"ALL":111.63,"AMD":476.391884,"ANG":1.785317,"AOA":362.0025,"ARS":58.2518,"AUD":1.487076,"AWG":1.8,"AZN":1.7025,"BAM":1.783801,"BBD":2,"BDT":84.512,"BGN":1.788093,"BHD":0.377036,"BIF":1845.18326,"BMD":1,"BND":1.350585,"BOB":6.91131,"BRL":4.186108,"BSD":1,"BTC":9.6315237e-5,"BTN":71.420419,"BWP":11.089014,"BYN":2.111699,"BZD":2.016112,"CAD":1.336234,"CDF":1665.300114,"CHF":0.990475,"CLF":0.025136,"CLP":725.5,"CNH":7.181872,"CNY":7.17735,"COP":3451.499866,"CRC":569.519351,"CUC":1,"CUP":25.75,"CVE":100.57,"CZK":23.675055,"DJF":178.05,"DKK":6.816888,"DOP":51.255,"DZD":120.634207,"EGP":16.58,"ERN":14.999589,"ETB":29.165827,"EUR":0.914286,"FJD":2.194544,"FKP":0.830972,"GBP":0.830972,"GEL":2.94,"GGP":0.830972,"GHS":5.4761,"GIP":0.830972,"GMD":50.49,"GNF":9183.897165,"GTQ":7.686547,"GYD":209.251519,"HKD":7.843863,"HNL":24.527801,"HRK":6.7698,"HTG":95.370231,"HUF":302.434638,"IDR":14212.5,"ILS":3.545195,"IMP":0.830972,"INR":72.324922,"IQD":1193.441127,"IRR":42105,"ISK":128.079698,"JEP":0.830972,"JMD":135.52,"JOD":0.709001,"JPY":106.17766667,"KES":103.81,"KGS":69.656201,"KHR":4091.097622,"KMF":448.049592,"KPW":900,"KRW":1215.65,"KWD":0.3043,"KYD":0.833448,"KZT":388.483485,"LAK":8773.714524,"LBP":1511.95,"LKR":180.21,"LRD":207.725217,"LSL":15.233211,"LYD":1.410406,"MAD":9.684529,"MDL":17.774713,"MGA":3734.693393,"MKD":56.214428,"MMK":1523.766831,"MNT":2665.685446,"MOP":8.079514,"MRO":357,"MRU":37.1655,"MUR":36.249,"MVR":15.449981,"MWK":724.958932,"MXN":20.1094,"MYR":4.218521,"MZN":61.435,"NAD":15.233211,"NGN":362.83,"NIO":33.534004,"NOK":9.153085,"NPR":114.279339,"NZD":1.59076,"OMR":0.384996,"PAB":1,"PEN":3.406348,"PGK":3.404468,"PHP":52.304,"PKR":156.75,"PLN":3.989786,"PYG":6253.188707,"QAR":3.640999,"RON":4.324992,"RSD":107.539398,"RUB":66.9993,"RWF":920.805965,"SAR":3.75065,"SBD":8.142811,"SCR":13.689263,"SDG":45.120905,"SEK":9.88198,"SGD":1.393249,"SHP":0.830972,"SLL":7288.043496,"SOS":578.601586,"SRD":7.458,"SSP":130.26,"STD":21560.79,"STN":22.4,"SVC":8.751261,"SYP":515.760137,"SZL":15.227627,"THB":30.676,"TJS":9.696847,"TMT":3.50998,"TND":2.862484,"TOP":2.328409,"TRY":5.766058,"TTD":6.76975,"TWD":31.392127,"TZS":2299.1,"UAH":25.289985,"UGX":3685.254955,"USD":1,"UYU":36.623346,"UZS":9376.017657,"VEF":248487.642241,"VES":17576.25,"VND":23247.237626,"VUV":116.747017,"WST":2.652378,"XAF":599.731974,"XAG":0.05408774,"XAU":0.00065327,"XCD":2.70255,"XDR":0.731955,"XOF":599.731974,"XPD":0.00065276,"XPF":109.103282,"XPT":0.00106523,"YER":250.350747,"ZAR":15.154615,"ZMW":13.108,"ZWL":322.000001}}]}};
    */
  };
  mpublic.get_currency_exchange_data = _get_currency_exchange_data;

  function _get_pay_intent(
    skey,
    // ~ amount, currency, method
    ){
    let _curl = 'https://api.stripe.com/v1/payment_intents';
    return fetch(
      _curl,
      {
        headers: {'Authorization': `Bearer ${skey}`},
        }
      );

    // -u sk_test_082qiZBiH26K7HAMfELTie4C00wz9kucjO: \
    // -d amount=1099 \
    // -d currency=eur \
    // -d payment_method_types[]=card

    // ~ let _curl = _get_url('get_miner');
    // ~ console.log(_curl);
    // ~ return _ajax.get(_curl);
  };
  mpublic.get_pay_intent = _get_pay_intent;

  // make application/x-www-form-urlencoded result from data
  function _form_body(data){
    var result = [];
    for (var property in data) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(data[property]);
      result.push(encodedKey + "=" + encodedValue);
    }
    result = result.join("&");
    return result;
  }

  function _create_pay_intent(
    skey, data
    // , card
    ){

    // curl https://api.stripe.com/v1/payment_intents \
    //     -u sk_test_082qiZBiH26K7HAMfELTie4C00wz9kucjO: \
    //     -d amount=2000 \
    //     -d currency=eur \
    //     -d payment_method_types[]=card

    let _curl = 'https://api.stripe.com/v1/payment_intents';
    return fetch(
      _curl,
      {
        method: 'POST',
        body: _form_body(data),
        // ~ body: JSON.stringify(data),
        headers: {
          'Authorization': `Bearer ${skey}`,
          // ~ 'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );
  };
  mpublic.create_pay_intent = _create_pay_intent;

  function _get_authorization_header(skey){
    return {
      'Authorization': `Bearer ${skey}`,
      'Accept': 'application/json',
      // ~ 'Content-Type': 'application/x-www-form-urlencoded',
      };
  }

  // get new subscription from server
  function _get_new_subscription(
    // ~ subs,
    category,
    months,
    skey,
    // ~ result,
    token
    ){
    let _curl = _get_url('get_new_subscription');
    let data = {
      'token': token,
      'category': category,
      'months': months,
      };
    return fetch(
      _curl,
      {
        method: 'POST',
        // ~ body: _form_body(data),
        body: JSON.stringify(data),
        headers: _get_authorization_header(skey),
        // headers: {
        //   'Authorization': `Bearer ${skey}`,
        //   'Accept': 'application/json',
        //   // ~ 'Content-Type': 'application/x-www-form-urlencoded',
        //   },
        }
      );
  }
  mpublic.get_new_subscription = _get_new_subscription;

  // activate subscription from server
  function _activate_subscription(
    subscription,
    skey,
    // ~ result,
    // ~ token
    ){
    let _curl = _get_url('activate_subscription');
    // let data = {
    //   'token': token,
    //   'category': subs.selected,
    //   'months': subs.months.selected,
    //   };
    return fetch(
      _curl,
      {
        method: 'POST',
        // ~ body: _form_body(data),
        body: JSON.stringify(subscription),
        headers: _get_authorization_header(skey),
        }
      );
  }
  mpublic.activate_subscription = _activate_subscription;

  // get payments data from server
  function _get_payment_data(){
    let _curl = _get_url('get_payment_data');
    return fetch(_curl);
    /* data like
      {
        src: 'https://js.stripe.com/v3/',
        key: 'pk_test_sx1PO5uOxAagIC3oLVQaCcO500UhcxWudT',
        skey: 'sk_test_082qiZBiH26K7HAMfELTie4C00wz9kucjO',
        currency: {
          zero_decimal: [
            'BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA', 'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF'
            ],
          },
        }
      }
    */
  }
  mpublic.get_payment_data = _get_payment_data;

  // get subscriptions deals data from server
  function _get_subscription_deals_data(){
    let _curl = _get_url('get_subscription_deals_data');
    return fetch(_curl);
  }
  mpublic.get_subscription_deals_data = _get_subscription_deals_data;

  // get subscriptions messages data from server
  function _get_subscription_messages_data(){
    let _curl = _get_url('get_subscription_messages_data');
    return fetch(_curl);
  }
  mpublic.get_subscription_messages_data = _get_subscription_messages_data;

  function _get_result(){
    return _ajax.result();
  }
  mpublic.result = _get_result;

  return mpublic;

});

export {
  Pronia,
  }
